export default __webpack_public_path__ + "static/media/flag-sudan.eaa39fd1.svg";